@if (invalidFields().length > 0) {
<div class="invalid-field-badges">
  @for (invalidField of invalidFields(); track invalidField.fieldName) {
  <button
    type="button"
    class="invalid-field-badge"
    (click)="selectField(invalidField.fieldName)">
    {{ invalidField.label }}
  </button>
  }
</div>
}
